import { createClient } from '@supabase/supabase-js'

// Project ID and credentials as per system instructions
const SUPABASE_URL = 'https://wjxptcvqzuxdmtxhlmak.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndqeHB0Y3ZxenV4ZG10eGhsbWFrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMyNzA2NjcsImV4cCI6MjA4ODg0NjY2N30.jDLJFgXNUHcaAsxs7678SF-auxP3q3EIWxxe5EEHhXY'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export default supabase;